import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const Timer = () => {
  const {t:translate} = useTranslation();
  const MAX_RECORDER_SECONDS = 10;
  const dispatch = useDispatch();
  const micActive = useSelector((state) => state.microphoneActive);
  const initialState = {
    recordingMinutes: 0,
    recordingSeconds: 0,
  };

  let recordingInterval = null;

  const [timerState, setTimerState] = useState(initialState);
  const formatMinutes = (minutes) => {
    return minutes < 10 ? `0${minutes}` : minutes;
  };

  const formatSeconds = (seconds) => {
    return seconds < 10 ? `0${seconds}` : seconds;
  };

  useEffect(() => {
    // const MAX_RECORDER_TIME = 1; //1 minute max recording time

    if (micActive === true) {
      recordingInterval = setInterval(() => {
        setTimerState((prevState) => {
          if (
            // prevState.recordingMinutes === MAX_RECORDER_TIME &&
            prevState.recordingSeconds === MAX_RECORDER_SECONDS
          ) {
            clearInterval(recordingInterval);
            return prevState;
          }

          if (
            prevState.recordingSeconds >= 0 &&
            prevState.recordingSeconds < 59
          ) {
            return {
              ...prevState,
              recordingSeconds: prevState.recordingSeconds + 1,
            };
          }

          if (prevState.recordingSeconds === 59) {
            return {
              ...prevState,
              recordingMinutes: prevState.recordingMinutes + 1,
              recordingSeconds: 0,
            };
          }
        });
      }, 1000);
    } else {
      clearInterval(recordingInterval);
    }

    return () => {
      clearInterval(recordingInterval);
      // setTimerState(initialState)
    };
  });

  useEffect(() => {
    if (timerState.recordingSeconds === MAX_RECORDER_SECONDS) {
      dispatch({
        type: 'setRecognitionText',
        payload: { text: translate('nothing-heard') },
      });
      dispatch({
        type: 'stopSpeechRecognition',
      });

      dispatch({
        type: 'deactivateMicrophone',
      });
    }
  }, [timerState]);

  useEffect(() => {
    if (micActive === false) {
      clearInterval(recordingInterval);
      setTimerState(initialState);
    }

    return () => {
      setTimerState(initialState);
    };
  }, [micActive]);

  return (
    <div className={`timer ${micActive === true ? 'timer--active' : ''}`}>
      <span>{formatMinutes(timerState.recordingMinutes)}</span>
      <span>:</span>
      <span>{formatSeconds(timerState.recordingSeconds)}</span>
    </div>
  );
};

export default Timer;
